const formFields = document.querySelectorAll('.form-input-wrapper--floating');

for (let i = 0; i < formFields.length; i++) {
	const fieldWrapper = formFields[i];
	const field = formFields[i].querySelector('input, textarea, select');

	if (field.value !== '') {
		fieldWrapper.classList.add('active');
	}

	field.addEventListener('focus', () => {
		fieldWrapper.classList.add('active');
	});

	field.addEventListener('blur', () => {
		if (field.value === '') {
			fieldWrapper.classList.remove('active');
		}
	});
}
